import component from './component';
import fixtures from './fixtures';

export default component;

export { component, fixtures };
